import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';
import {
	PermissionName,
	PermissionMatrixName,
} from '@netx/core-permissions-next/enablers';
import type {ICategory} from '../schema';
import {categoryPermissionChecker} from '@netx/core-permissions-next/utils';

export const canCreateShareLinkFromCategory = (
	category?: ICategory,
): boolean => {
	if (category == null) return false;
	if (!currentUserMeetsUserLevel(UserLevel.CONSUMER)) return false;
	return categoryPermissionChecker({
		category,
		permissionName: PermissionName.CREATE_SHARE_LINKS,
		permissionMatrixName: PermissionMatrixName.DOWNLOAD,
	});
};
